import React from "react";
import './about.css'
import ME from "../../assets/family.jpg"
import { profile } from "../../data/profile";

const About = () => {
    return(
        <section id="about">
            <div className="container">
                <span className="section__eyebrow">About</span>
                <h2 className="section__title">A bit about me</h2>

                <div className="about__container reveal">
                    <div className="about__content">
                        <p className="text-muted">{profile.about}</p>

                        <ul className="about__stats">
                            {profile.stats.map(({ value, label, detail }) => (
                                <li key={label} className="about__stat">
                                    <strong>{value}</strong>
                                    <span className="about__stat-label">{label}</span>
                                    <span className="about__stat-detail text-muted">{detail}</span>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="about__me-image">
                        <img src={ME} alt={`${profile.name} with family`} />
                    </div>
                </div>
            </div>
        </section>
    )
}

export default About
